export default {
  '*Id': '_',
  CompanyNameWithEoNumber: {
    label: 'Company Profile Name (EO Number)',
    width: 200
  },
  CompanyLegalName: {
    label: 'Legal Company Name',
    width: 140
  },
  City: {
    label: 'City',
    width: 75
  },
  StateRegion: {
    label: 'State/Region',
    type: 'text',
    width: 80
  },
  InsuranceStatus: {
    label: 'Status',
    width: 90
  },
  ExpirationDate: {
    label: 'Expiration Date',
    width: 90
  },
  ShouldBeVerified: {
    label: 'Pending Verification',
    width: 105,
    options: [
      { name: 'Yes' },
      { name: 'No' }
    ],
    type: 'list'
  },
  $$view: {
    label: 'View Details',
    uri: '#/d/Network/insurance-view-details?Id={{id}}'
  }
}



// WEBPACK FOOTER //
// ./src/components/_modules/Network/Insurance/models/supplier-model.js